import { render, staticRenderFns } from "./UserUpdateForm.vue?vue&type=template&id=bfc6f6b0&scoped=true&"
import script from "./UserUpdateForm.vue?vue&type=script&lang=js&"
export * from "./UserUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc6f6b0",
  null
  
)

export default component.exports